import defineComponent from 'flight';
import WithAjax from 'static/script/app/data/with-ajax';
import ShopItemSettingsModalDiscount from 'static/script/app/ui/shop-item-settings-modal-discount';
import ShopItemSettingsModalOnDisplay from 'static/script/app/ui/shop-item-settings-modal-on-display';

function ShopItemSettingsModal() {

    this.defaultAttrs({
        saveButton: '[data-shop-item-settings-save-button]',
        onDisplayBody: '[data-shop-item-settings-modal-on-display]',
        discountBody: '[data-shop-item-settings-modal-discount]',
        itemId: null,
        onDisplay: null,
        onDisplayCount: null,
        maxOnDisplayCount: null,
        discountCount: null,
        maxDiscountCount: null,
        priceBeforeDiscount: null,
        discountRate: null,
        canHaveDiscount: null
    });

    this._saveSettings = function (e) {
        e.preventDefault();
        e.stopPropagation();

        let data = {};
        this.trigger(document, 'ui:shop-item-settings-modal:save', data);

        let payload = {
            itemId: this.attr.itemId,
            onDisplay: data.onDisplay,
            discountRate: data.discountRate
        };

        this._post({
            url: '/profile/shop-item-settings/settings',
            data: payload
        });

        this.trigger(document, 'ui:modal:close');
    };

    this._close = function () {
        this.teardown();
    };

    this.after('initialize', function () {
        this.on('click', {
            saveButton: this._saveSettings
        });
        this.on(document, 'ui:body-container:on-modal-close', this._close);
        ShopItemSettingsModalOnDisplay.attachTo(this.attr.onDisplayBody, {
            itemId: this.attr.itemId,
            onDisplay: this.attr.onDisplay,
            onDisplayCount: this.attr.onDisplayCount,
            maxOnDisplayCount: this.attr.maxOnDisplayCount
        });

        if (this.attr.canHaveDiscount) {
            ShopItemSettingsModalDiscount.attachTo(this.attr.discountBody, {
                itemId: this.attr.itemId,
                priceBeforeDiscount: this.attr.priceBeforeDiscount,
                discountRate: this.attr.discountRate,
                discountCount: this.attr.discountCount,
                maxDiscountCount: this.attr.maxDiscountCount
            });
        } else {
            this.select('discountBody').hide();
        }
    });

    this.around('teardown', function() {
        this.off(document, 'ui:body-container:on-modal-close', this._close);
    });
}

module.exports = defineComponent.component(ShopItemSettingsModal, WithAjax);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/shop-item-settings-modal.js